/**
 * Pipelines (Air Traffic Control) API Hooks
 */

import { useApiData, useAuthenticatedFetch } from './client';
import type { Pipeline, PipelineDataSource } from './types';

export function usePipelineStatus(projectId: number | undefined) {
  const endpoint = projectId ? `/internal/pipelines/${projectId}/status` : null;
  return useApiData<Pipeline>(endpoint || '/internal/pipelines/0/status');
}

export function usePipelineDataSources(projectId: number | undefined) {
  const endpoint = projectId ? `/internal/pipelines/${projectId}/datasources` : null;
  return useApiData<PipelineDataSource[]>(endpoint || '/internal/pipelines/0/datasources');
}

export function usePipelineMutations() {
  const { fetchData: fetchLaunch } = useAuthenticatedFetch<Pipeline>();
  const { fetchData: fetchTerminate } = useAuthenticatedFetch<Pipeline>();
  const { fetchData: fetchDelete } = useAuthenticatedFetch<void>();

  const launch = (projectId: number) =>
    fetchLaunch('/internal/pipelines/launch', {
      method: 'POST',
      body: JSON.stringify({ id_project: projectId }),
    });

  const terminate = (projectId: number) =>
    fetchTerminate(`/internal/pipelines/${projectId}/terminate`, {
      method: 'POST',
    });

  const deletePipeline = (projectId: number) =>
    fetchDelete(`/internal/pipelines/${projectId}`, {
      method: 'DELETE',
    });

  return { launch, terminate, deletePipeline };
}
